<script setup lang="ts">
import { computed, onBeforeMount, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { SET_REQUEST_LOADING } from '@/store/mutation-types'
import LegalsModal from '@/components/views/login-registration/modals/LegalsModal.vue'

const store = useStore()
const route = useRoute()

const requestLoading = computed(() => store.state.requestLoading)
const isModalVisible = computed(
  () => store.state.termsModalIsVisible || store.state.privacyModalIsVisible
)
const showNavbar = computed(
  () =>
    route.name !== 'DONOR_FLOW_ManageAccountUserNotFound' &&
    route.name !== 'Login' &&
    route.name !== 'DONOR_FLOW_ManageAccountCloseConfirm'
)

onBeforeMount(() => {
  document.body.classList.add('manage-account')
  // Ensure content renders, many manage-account routes redirect before
  // route-level setRequestLoadingFalse runs, leaving the spinner stuck.
  store.commit(SET_REQUEST_LOADING, false)
})

onUnmounted(() => {
  document.body.classList.remove('manage-account')
})
</script>

<template>
  <div>
    <div class="support-navigation">
      <div class="container">
        <nav v-if="showNavbar" class="navbar navbar-expand-lg navbar-light">
          <router-link
            :to="{ name: 'Dashboard' }"
            class="support-navigation__back-button small fw-bold"
          >
            <i class="fas fa-chevron-left fa-xs"></i>
            Dashboard
          </router-link>
        </nav>
      </div>
    </div>

    <div
      v-if="requestLoading"
      class="align-items-center bottom-0 d-flex end-0 justify-content-center position-absolute start-0 top-0"
      role="status"
      aria-live="polite"
    >
      <div class="spinner small" aria-hidden="true"></div>
    </div>

    <section v-else class="hero-area">
      <div class="container">
        <router-view role="main"></router-view>
      </div>
    </section>

    <LegalsModal v-if="isModalVisible" />
  </div>
</template>

<style lang="scss">
body.manage-account::-webkit-scrollbar {
  width: 1em;
}

body.manage-account::-webkit-scrollbar-track {
  box-shadow: none;
}

body.manage-account::-webkit-scrollbar-thumb {
  background-color: var(--mid-grey);
}

.hero-area {
  padding-top: 100px;

  @media (min-width: 768px) {
    padding-top: 200px;
  }
}

.support-navigation {
  .navbar {
    height: auto;
    box-shadow: none;
    background-color: transparent;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 0;
    padding-right: 0;
  }

  .navbar .small {
    transform: scale(0.8);
  }

  &__back-button {
    font-weight: 700;
    display: flex;
    align-items: center;
    color: var(--mid-grey);
    background-color: rgba(var(--white), 0.8);
    border: none;
    padding: 10px 20px;
    transition: color 0.2s ease-in-out;
    transition-delay: initial;
    border-radius: 5px;

    .fas {
      margin-right: 8px;
    }
  }
}
</style>
